"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmBadge = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
exports.SmBadge = react_1.default.forwardRef((_a, ref) => {
    var { variant = 'primary', size = 'medium', icon, text, isNotification = false, position = 'topRight', className, children } = _a, props = __rest(_a, ["variant", "size", "icon", "text", "isNotification", "position", "className", "children"]);
    const badgeClassName = (0, classnames_1.default)('c-badge', isNotification ? `-notification -${position}` : `-${size} -${variant}`, className);
    return !isNotification ? (react_1.default.createElement("span", Object.assign({}, props, { ref: ref, className: badgeClassName, role: "status" }),
        icon && (react_1.default.createElement("span", { className: "mr-2 d-flex justify-content-center" }, icon)),
        text)) : (react_1.default.createElement("span", { className: "c-badge__container" },
        children,
        react_1.default.createElement("span", Object.assign({}, props, { ref: ref, className: badgeClassName, role: "status" }), text)));
});
//# sourceMappingURL=index.js.map